import { NotificationHandler } from './notification-handler.interface';
import { Notification } from './notification.interface';
import { UserNotification } from './user-notification.interface';

/**
 * Handler that does nothing
 * Required because we allow multiple providers for 'SIGNALR_NOTIFICATION_HANDLER' but it's not possible to make them optional
 */
export class NullSignalRNotificationHandler implements NotificationHandler<unknown> {
	dataType: string = undefined;

	handleNotification(notification: Notification<unknown>): void {
		// Do nothing
	}
	formatUserNotification(notification: Notification<unknown>): UserNotification<unknown> {
		return null;
	}

	onClick(notification: UserNotification<unknown>) {
		// Do nothing
	}
}
